class CollectionCarousel extends HTMLElement {
    constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.sectionId = this.dataset.sectionId;
        this.pagination = this.dataset.pagination == 'true';
        this.mobileSpaceBetween = this.dataset.mobileSpaceBetween || '16';
        this.desktopSpaceBetween = this.dataset.desktopSpaceBetween || '44';
    }

    connectedCallback() {
        this.enableSwiper();
    }

    enableSwiper() {
        const configuration =  {
            spaceBetween: this.isMobile ? this.mobileSpaceBetween : this.desktopSpaceBetween,
            slidesPerView: 'auto',
            centeredSlides: false,
            freeMode: {
                enabled: true,
            },
            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
            },
        }

        if (!this.isMobile && this.pagination) {
            configuration['pagination'] = {
                el: `.${this.sectionId} .swiper-pagination`,
                type: "progressbar",
            }
        }

        new Swiper(this.querySelector('.swiper-container'), configuration);
    }
}
customElements.define('collection-carousel', CollectionCarousel);
